const SCHEDULE_SLOT_MINUTES = 30

export const SCHEDULE_SLOT_MS = SCHEDULE_SLOT_MINUTES * 60 * 1000

/**
 * Floor to the previous LOCAL :00/:30 boundary (seconds/ms zeroed).
 *
 * Local time, not UTC: the schedule's FullCalendar grid and the bookable-slot
 * generator (Schedule/service.ts buildFreeSlots) both operate in local time,
 * and UTC snapping drifts off the local grid in :45-offset zones.
 *
 * Floor, not nearest: the snapped start must never be in the future
 * (downstream filters assume period.start <= now) and must never cross
 * midnight into a different service date.
 */
export function snapToScheduleGrid(date: Date = new Date()): Date {
  const snapped = new Date(date)
  snapped.setSeconds(0, 0)
  snapped.setMinutes(snapped.getMinutes() - (snapped.getMinutes() % SCHEDULE_SLOT_MINUTES))
  // When the floored wall time falls inside a DST spring-forward gap that
  // skips a :00/:30 line (only :45-offset zones, e.g. Pacific/Chatham), JS
  // resolves it FORWARD past the input — clamp back so the never-in-the-
  // future invariant holds even there, at the cost of an off-grid minute
  // during that one gap.
  while (snapped.getTime() > date.getTime()) {
    snapped.setTime(snapped.getTime() - SCHEDULE_SLOT_MS)
  }
  return snapped
}
